import React from 'react';
import DodgeLogo from "./assets/Dodge-logo.png";
import MOPAR from "./assets/MOPAR.png";
import jeep from "./assets/jeep.jpg";
import Chrysler from "./assets/Chrysler.png";
import RAM from "./assets/RAM.jpg";

import SRT from "./assets/SRT.png";
import Ford from "./assets/Ford.jpg";
import Motorcraft from "./assets/Motorcraft.png";
import GM from "./assets/GM.jpg";
import ACDelco from "./assets/ACDelco.png";

const brandData = [
  {
    name: 'MOPAR',
    logo: (
  <img
    src={MOPAR}
    alt="Mopar"
    className="brand-logo"
  />
)
  },
  {
    name: 'Dodge',
    logo: (
  <img
    src={DodgeLogo}
    alt="DodgeLogo"
    className="brand-logo"
  />
)
  },
  {
    name: 'Jeep',
    logo: (
  <img
    src={jeep}
    alt="jeep"
    className="brand-logo"
  />
)
  },
  {
    name: 'Chrysler',
    logo: (
  <img
    src={Chrysler}
    alt="Chrysler"
    className="brand-logo"
  />
)
  },
  {
    name: 'RAM',
    logo: (
  <img
    src={RAM}
    alt="RAM"
    className="brand-logo"
  />
)
  },
  {
  name: 'SRT',
  logo: (
    <img
      src={SRT}
      alt="SRT"
      className="brand-logo"
    />
  )
},
{
  name: 'Ford',
  logo: (
    <img
      src={Ford}
      alt="Ford"
      className="brand-logo"
    />
  )
},
{
  name: 'Motorcraft',
  logo: (
    <img
      src={Motorcraft}
      alt="Motorcraft"
      className="brand-logo"
    />
  )
},
{
  name: 'GM',
  logo: (
    <img
      src={GM}
      alt="GM"
      className="brand-logo"
    />
  )
},
{
  name: 'ACDelco',
  logo: (
    <img
      src={ACDelco}
      alt="ACDelco"
      className="brand-logo"
    />
  )
}
];

const Brands = () => {
  return (
    <section className="brands" id="brands">
      <div className="container">
        <div className="section-header light reveal">
          <span className="label">Featured Brands</span>
          <h2>Premium <span className="highlight">Genuine</span> Parts Portfolio</h2>
          <p>We supply only 100% genuine OEM parts from the world's most trusted American automotive brands.</p>
        </div>

        <div className="brands-grid">
          {brandData.map((brand, index) => (
            <div key={index} className={`brand-card reveal reveal-delay-${(index % 5) + 1} glass-reflection`}>
              <div className="glow"></div>
              <div className="brand-logo-wrapper">{brand.logo}</div>
              <div className="brand-sub">Genuine Parts</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Brands;